module.exports = __webpack_public_path__ + "img/heart@2x.0dfa1b5d.png";